<template>
  <b-modal
      id="bv-modal-number"
      ref="modal"
      :title="title"
      data-test-path="dialog-select-in-combo"
      modal-class="footer-dialog"
      @hide="onHide"
      @ok="onOk"
  >
    <b-container class="px-3 mx-0" fluid="true">
      <b-row>
        <b-col cols="6">
          <reach-input
              :formField="minFormField"
              label="Min"
          >
          </reach-input>
        </b-col>
        <b-col cols="6">
          <reach-input
              :formField="maxFormField"
              label="Max"
          >
          </reach-input>
        </b-col>
      </b-row>
      <b-row v-if="numberErrorMessage && min && max">
        <b-col>
          <small class="form-text text-danger pt-2">
            {{$tr('numericDialog.maximumValue.Cannot.Lower',
              'The maximum value cannot be lower than the minimum')}}
          </small>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer="{close}">
      <FooterNavbar class="w-100 m-0 text-center" data-test-path="select-in-data-grid-footer">
        <footer-button type="Cancel" @cancel="cancel"></footer-button>
        <FooterButton :disabled="(numberErrorMessage && min !== null && max !== null)
          || (min === null && max === null)" type="Ok" @ok="onOk"></FooterButton>
      </FooterNavbar>
    </template>
  </b-modal>
</template>

<script>
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import DateTimePicker from "@/components/inputs/DateTimePicker";
import moment from "moment-timezone";
import ReachInput from "@/components/inputs/ReachInput.vue";
import ValidatedField from "@/validation/ValidatedField";
import Rpc from "@/Rpc";

moment.suppressDeprecationWarnings = true;

export default {
  name: "NumericDialog",
  components: {ReachInput, DateTimePicker, FooterButton, VBox, FooterNavbar, CloseButton},

  methods: {

    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(null);
        this.resolve = null;
      }
    },

    async onOk() {
      if (this.resolve != null) {
        this.resolve({"min": this.min, "max": this.max});
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    async cancel() {
      this.$refs.modal.hide();
    },


    reset() {
      this.minFormField = new ValidatedField();
      this.minFormField.value = this.min;
      this.minFormField.isValid = true;

      this.maxFormField = new ValidatedField();
      this.maxFormField.value = this.max;
      this.maxFormField.isValid = true;

      this.result = null;
      this.resolve = null;
    },


  },

  watch: {
    'minFormField.value': function (val) {
      this.min = val;
    },
    'maxFormField.value': function (val) {
      this.max = val;
    },
  },

  data: () => ({
    numberErrorMessage: false,
    title: "",
    resolve: null,
    result: null,
    min: null,
    max: null,
    minFormField: new ValidatedField(),
    maxFormField: new ValidatedField()
  })
}
</script>
